import { render, staticRenderFns } from "./BoxAnotacoes.vue?vue&type=template&id=0273da4c&"
import script from "./BoxAnotacoes.vue?vue&type=script&lang=js&"
export * from "./BoxAnotacoes.vue?vue&type=script&lang=js&"
import style0 from "./BoxAnotacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports